module.exports = __webpack_public_path__ + "static/media/benefits3.35235875.jpg";